import { Component } from 'react';
import h from 'react-hyperscript';

import './Nav.css';

const NavItems = [
  { href: '#header', text: 'Home', el: null },
  { href: '#service', text: 'Services', el: null },
  {
    href: '#header',
    el: h('img', { src: 'img/logo-scllc-dark.png', alt: 'Simple City logo' }),
    className: 'small-logo',
  },
  { href: '#team', text: 'Team', el: null },
  { href: '#contact', text: 'Contact', el: null },
].map(ni => {
  const { href, text, el, className = null } = ni;

  return h('li', { className }, [h('a', { href }, text || el)]);
});

const NAV_EL_ID = 'nav';

class Nav extends Component {
  /* istanbul ignore next */
  componentDidMount() {
    if (!window.$) return;

    const { $ } = window;

    $(window).resize(() => {
      if ($(window).width() < 768) {
        $('.main-nav').hide();
      } else {
        $('.main-nav').removeAttr('style');
      }
    });

    $(`#${NAV_EL_ID}`).scrollToFixed();

    $('.res-nav_click').click(() => {
      $('.main-nav').slideToggle();

      return false;
    });

    $('.main-nav li a, .servicelink').bind('click', function onClick(event) {
      const $anchor = $(this);
      const isSmallViewPort = $(window).width() < 768;

      $('html, body')
        .stop()
        .animate(
          {
            scrollTop: $($anchor.attr('href')).offset().top - 50,
          },
          1500,
          'easeInOutExpo',
        );

      if (isSmallViewPort) {
        $('.main-nav').slideUp();
      }

      event.preventDefault();
    });
  }
  render() {
    return h(`nav#${NAV_EL_ID}.main-nav-outer`, [
      h('.container', [h('ul.main-nav', NavItems), h('a.res-nav_click', { href: '#' }, [h('i.fa.fa-bars')])]),
    ]);
  }
}

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js